import type { ListBuilderConfiguration } from '../types';
import { competitorLinkDetailColumns } from './competitor-customers-embedded.config';

/**
 * PD-17066 — a customer's Competitors tab: the competitors this customer
 * buys from, with the relationship, product groups, estimated spend, note and
 * last confirmation. Rows are `client_wholesaler` links from
 * GET /api/competitor-links/client/:clientId (a customer has a handful, so the
 * tab loads them in one request).
 */
const TABLE = 'client_wholesaler';

export const CLIENT_COMPETITORS_EMBEDDED_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-client-competitors',
			cacheTTL: 600000,
			name: 'Competitors',
			type: 'default',
			active: true,
			sortOrder: 0,
			columns: [
				{
					id: 'link-competitor',
					fields: [
						{
							id: 'link-competitor-name',
							link: {
								type: 'object',
								enabled: true,
								objectTable: 'wholesaler',
								idField: 'competitorId',
							},
							dataConfig: {
								type: 'field',
								field: { fieldName: 'competitorName', objectTable: TABLE },
								defaultValue: '-',
							},
							styleConfig: { size: 'md', weight: 'medium', colorRule: { type: 'default' } },
							displayStyle: 'text',
						},
						{
							id: 'link-competitor-lb1',
							dataConfig: { type: 'custom_text', customText: '' },
							displayStyle: 'line_break',
							conditionalVisibility: {
								field: 'inactiveCompetitorLabel',
								condition: 'is_not_null',
							},
						},
						{
							id: 'link-competitor-inactive',
							dataConfig: {
								type: 'field',
								field: { fieldName: 'inactiveCompetitorLabel', objectTable: TABLE },
							},
							styleConfig: {
								size: 'xs',
								valueMapping: [
									{ value: 'Inactive', label: 'Inactive', color: { type: 'neutral' } },
								],
							},
							displayStyle: 'badge',
							conditionalVisibility: {
								field: 'inactiveCompetitorLabel',
								condition: 'is_not_null',
							},
						},
					],
					headers: [{ id: 'h-competitor', text: 'Competitor' }],
					minWidth: 180,
					sortable: false,
					alignment: 'left',
					widthConfig: { mode: 'flexible', preset: 'medium' },
					verticalAlignment: 'top',
				},
				...competitorLinkDetailColumns().filter(
					// Our sales to this customer are on the customer's own pages.
					(column) => column.id !== 'link-our-sales',
				),
			],
		},
	],
	paging: {
		defaultPageSize: 50,
		pageSizeOptions: [50],
	},
	filters: {
		activeFilters: [],
		defaultFilters: {},
	},
	objects: [
		{
			objectLabel: 'Competitor Link',
			objectTable: TABLE,
			// Rows are client_wholesaler links keyed by `id`.
			rowIdField: 'id',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'relationship', fieldLabel: 'Relationship' },
				{ fieldName: 'estimatedAnnualSpend', fieldLabel: 'Estimated Annual Spend' },
				{ fieldName: 'note', fieldLabel: 'Note' },
				{ fieldName: 'confirmedDate', fieldLabel: 'Confirmed' },
			],
		},
		{
			baseUrl: '/competitors/:id',
			objectLabel: 'Competitor',
			objectTable: 'wholesaler',
			selectedFields: [{ fieldName: 'competitorId', fieldLabel: 'ID' }],
		},
	],
};
